export const GET_ALL_CITY = 'GET_ALL_CITY';
export const LEDGER_FETCH_ERROR = 'LEDGER_FETCH_ERROR';
export const REMOVE_LEADER_DATA = 'REMOVE_LEADER_DATA';
